<template>
    <el-breadcrumb separator="/" class="app-breadcrumb">
        <template v-for="(item, idx) in items" :key="idx">
            <el-breadcrumb-item v-if="item.to" :to="{ path: item.to }">
                {{ item.text }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-else>
                {{ item.text }}
            </el-breadcrumb-item>
        </template>
    </el-breadcrumb>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
const AppBreadcrumb = defineComponent({
    props: {
        items: {
            type: Object as PropType<any[]>,
        },
    },
});
export default AppBreadcrumb;
</script>
<style>
.app-breadcrumb {
    padding: 20px 0;
}
</style>
